import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import SideMenu from './components/SideMenu';
import ActorLayout from './actor/ActorLayout';

import './styles/Hero.css';
import './styles/About.css';
import './styles/SideMenu.css';

function App() {
  const storedDarkMode = localStorage.getItem('darkMode') === 'true';
  const [darkMode, setDarkMode] = useState(storedDarkMode);

  useEffect(() => {
    document.body.classList.toggle('dark', darkMode);
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(prev => !prev);

  return (
    <Router>
      {/* Developer Site UI */}
      <Routes>
        <Route
          path="/actor/*"
          element={<ActorLayout darkMode={darkMode} toggleDarkMode={toggleDarkMode} />}
        />

        <Route
          path="/*"
          element={
            <>
              <SideMenu darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
              <Routes>
                <Route path="/" element={<Hero darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
                <Route path="/about" element={<About darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
                <Route path="/projects" element={<Projects darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
                <Route path="/contact" element={<Contact darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
              </Routes>
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
